import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { addSortingConfig, deleteSortingConfig, handleCurrentConfig, setCurrentPlan, updateSortingConfig } from '../../actions/sortingMachineManagementActions';
import { getOpenCreateEditSortingMachineDialog, handleOpenCreateEditSortingMachineDialog, showAlertSnackbar } from '../../reducers/uiSlice';
import FullscreenLoading from '../Common/FullscreenLoading';
import UniDialog from '../Common/UniDialog';
import SortingPlanDetail from './SortingPlanDetail';

function CreateEditModal(props) {
    const dispatch = useDispatch();
    const { t } = useTranslation('sortingMachineManagement');

    const dialogObj = useSelector(getOpenCreateEditSortingMachineDialog);
    const presetSaved = useSelector(state => state.smmReducer.preset);
    const currentConfigId = useSelector(state => state.smmReducer.configId);
    const isActive = useSelector(state => state.smmReducer.isActive);

    const REQUIRED_PARAMS = ['name', 'machine_code', 'sorting_type', 'config_items']

    const [params, setParams] = useState({});
    const [loading, setLoading] = useState(false);
    const [closeAlertOpen, setCloseAlertOpen] = useState(false);
    const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);

    const handleParams = (paramsObj) => {
        setParams(paramsObj);
    }

    const handleAddConfig = async (type) => {
        const verified = await handleVerify();
        try {
            setLoading(true);
            if (verified) {
                let configId;
                if (dialogObj.type === 'CREATE') {
                    const res = await dispatch(addSortingConfig(params));
                    configId = res.config_id;
                } else {
                    configId = presetSaved.preset.id;
                    await dispatch(updateSortingConfig({
                        ...params,
                        config_id: configId
                    }))
                }

                if (type === 'set') {
                    await dispatch(setCurrentPlan({
                        config_id: configId,
                        machine_code: params.machine_code
                    }))
                }
                dispatch(showAlertSnackbar({ message: t('update_success'), type: 'success' }))
                await dispatch(handleOpenCreateEditSortingMachineDialog({
                    open: false,
                    type: ''
                }))
                await window.location.reload();
            } else {
                dispatch(showAlertSnackbar({ message: t('please_fill_all'), type: 'error' }))
            }
        } catch (e) {
            if (verified) {
                dispatch(showAlertSnackbar({ message: e.message, type: 'error' }))
            }
        } finally {
            setLoading(false);
        }
    }

    const handleVerify = () => {
        let verified = true;
        REQUIRED_PARAMS.filter((key) => {
            if (!params[key] || !params[key]?.length) {
                verified = false;
            }
        })
        return verified;
    }

    const handleDialogClose = () => {
        dispatch(handleOpenCreateEditSortingMachineDialog({
            open: false,
            type: ''
        }))
    }

    const handleDeleteConfig = () => {
        setLoading(true);
        dispatch(deleteSortingConfig({ 'config_id': currentConfigId }))
            .then(() => {
                dispatch(handleCurrentConfig('', false));
                dispatch(showAlertSnackbar({ message: t('delete_success'), type: 'success' }))
                handleDialogClose();
                window.location.reload();
            })
            .catch(() => {
                dispatch(showAlertSnackbar({ message: t('delete_failure'), type: 'error' }))
            })
            .finally(() => {
                setLoading(false);
            })
    }

    return (
        <UniDialog
            title={dialogObj.type === 'CREATE' ? t('create_new') : t('preset_title') + ' ' + presetSaved?.preset?.name}
            fullWidth
            maxWidth='lg'
            open={dialogObj.open}
            disableBackClick={true}
            enableDelete={dialogObj.open && dialogObj.type === 'EDIT' && !isActive}
            onDelete={() => setDeleteAlertOpen(true)}
            onClose={() => {
                setCloseAlertOpen(true);
            }}
            disableDefaultButtons
            buttons={[
                {
                    color: 'primary',
                    text: t('common:save'),
                    action: () => {
                        handleAddConfig();
                    }
                },
                {
                    color: 'primary',
                    text: t('common:save_activate'),
                    action: () => {
                        handleAddConfig('set');
                    }
                }
            ]}
        >
            <SortingPlanDetail
                sortingCenters={props.sortingCenters}
                handleParams={handleParams}
            />
            <FullscreenLoading open={loading} />
            <UniDialog
                open={closeAlertOpen}
                title={t('unsaved_changes')}
                onClose={() => setCloseAlertOpen(false)}
                onFinish={handleDialogClose}
                cancelButtonText={t('common:cancel')}
                finishButtonText={t('common:ok')}
            >
                {t('unsaved_changes_memo')}
            </UniDialog>
            <UniDialog
                open={deleteAlertOpen}
                title={t('confirm_deletion')}
                onClose={() => setDeleteAlertOpen(false)}
                onFinish={handleDeleteConfig}
                cancelButtonText={t('common:cancel')}
                finishButtonText={t('common:ok')}
            >
                {t('delete_confirm_memo')}
            </UniDialog>
        </UniDialog>
    )
}
export default CreateEditModal;